export const na1 = 'na1';
export const na2 = 'na2';
export const na3 = 'na3';
export const eu1 = 'eu1';
export const ap1 = 'ap1';
export const test2 = 'test2';